import styled from "styled-components";
import { IconButton } from "../../components";
import VirtualTable, { TableRecordCountDisplayFooter } from "../../components/tables/VirtualTable";
import { FiltersAppliedWarningMessage, PageSubHeader, ThemedIcon } from "../../components/utilities";
import Dropdown from "../../components/utilities/Dropdown";
import { useFilterContext } from "../../hooks/FilterContext";
import NewBusinessRegisterFiltersModal from "./components/NewBusinessRegisterFiltersModal";
import NewBusinessRegisterTableHeader from "./components/NewBusinessRegisterTableHeader";
import NewBusinessRegisterTableRow from "./components/NewBusinessRegisterTableRow";
import useNewBusinessRegister from "./hooks/useNewBusinessRegister";

const FilterHeader = styled(PageSubHeader)`
    padding: 0.75rem;
`;

const NewBusinessRegister = () => {

    const {
        clear,
        data,
        error,
        isClearing,
        isRowLoaded,
        loadMore,
        currentSort,
        sortTable,
        totalCount,
        exportCsv
    } = useNewBusinessRegister();
    const { setShowFilterModal, isFiltersApplied, clearFilter } = useFilterContext();

    return <>
        <NewBusinessRegisterFiltersModal />
        <FilterHeader>
            <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                    {isFiltersApplied && (
                        <>
                            <ThemedIcon icon="fa-triangle-exclamation" size="2x" variant="warning" />
                            <FiltersAppliedWarningMessage className="ms-2 text-muted">
                                Warning - Filters are currently being applied to your results.
                                <br />
                                <button className="anchor" onClick={clearFilter}>Click here</button> to clear your filters.
                            </FiltersAppliedWarningMessage>
                        </>
                    )}
                </div>
                <div className="d-flex flex-fill justify-content-end align-items-center gap-2">
                    <IconButton
                        icon={['fas', 'filter']}
                        onClick={() => setShowFilterModal(true)}
                        menu={[
                            <Dropdown.Menu>
                                <Dropdown.MenuItem icon={['fas', 'download']} text="Export Register" onClick={exportCsv} />
                            </Dropdown.Menu>
                        ]}
                    >
                        Filter Register
                    </IconButton>
                </div>
            </div>
        </FilterHeader>
        <section className="h-100 px-4 my-3">
            <VirtualTable
                enableScrollTracking
                row={NewBusinessRegisterTableRow}
                header={<NewBusinessRegisterTableHeader currentSort={currentSort} sortTable={sortTable} />}
                footer={(
                    !isClearing && <TableRecordCountDisplayFooter
                        spanLeft={11}
                        spanRight={1}
                        totalCount={totalCount}
                        reload={clear}
                    />
                )}
                isLoading={isClearing}
                error={error}
                isItemLoaded={isRowLoaded}
                loadMoreItems={loadMore}
                itemSize={45}
                itemCount={totalCount}
                itemData={data}
            />
        </section>
    </>;
}

export default NewBusinessRegister;